// Fonte única dos temas: cruza PERFIL (comum/admin/operador) × MODO (light/dark).
// Também corrige o `import theme from '.'` do styled.d.ts (tipagem do DefaultTheme).

import { comum, admin, operador } from './light';
import {
    comum as comumDark,
    admin as adminDark,
    operador as operadorDark,
} from './dark';

export type ThemeMode = 'light' | 'dark';
export type ThemeProfile = 'comum' | 'admin' | 'operador';

const themes = {
    light: { comum, admin, operador },
    dark: { comum: comumDark, admin: adminDark, operador: operadorDark },
};

/**
 * Retorna o theme do styled-components para um perfil + modo.
 * Perfis desconhecidos (ex.: 'Solicitante', 'Profissional') caem em 'comum'.
 */
export function getTheme(profile: string | undefined, mode: ThemeMode) {
    const byMode = themes[mode] ?? themes.light;
    return byMode[profile as ThemeProfile] ?? byMode.comum;
}

// Default export = formato de referência usado pelo styled.d.ts (DefaultTheme).
export default comum;
